module.exports = __webpack_public_path__ + "icon-fence-wirestrength-strong.svg?fa3de672ded11996c08c95f53f6243b0";